import { Resource, ResourcesStore } from '../../types'

export const setSelectedResource =
  (selectedResource: Resource | null) => (draft: ResourcesStore) => {
    if (!selectedResource) {
      draft.selectedResource = null
      return
    }

    draft.selectedResource = selectedResource
    draft.resources.forEach((resource) => {
      if (resource.resourceId !== selectedResource.resourceId && resource.isNew) {
        Object.assign(resource, { isNew: false })
      }
    })
  }

export const updateResource = (updatedResource: Resource) => (draft: ResourcesStore) => {
  const index = draft.resources.findIndex(
    (resource) => resource.resourceId === updatedResource.resourceId
  )
  if (index !== -1) {
    draft.resources[index] = { ...draft.resources[index], ...updatedResource }
  }
}

export const archiveResource = (resourceId: string) => (draft: ResourcesStore) => {
  draft.resources = draft.resources.filter((resource) => resource.resourceId !== resourceId)
  if (draft.selectedResource && draft.selectedResource.resourceId === resourceId) {
    draft.selectedResource = draft.resources.length > 0 ? draft.resources[0] : null
  }
}
